module.exports = require("./lib/jquery").extend;
